import React from "react";
// import { BrowserRouter as Router, Routes, Route, Form } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import ContctUs from "./pages/ContctUs";

const App = () => {
  return (
    <Router>
      <Header />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/Service" element={<Services />} />
          <Route path="/Contactus" element={<ContctUs />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;
